var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBell48Line = function SvgIconBell48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7 30.45v-9.3a10.71 10.71 0 0 0-9-10.55V8.15h-3.4v2.45a10.71 10.71 0 0 0-9 10.55v9.3H11v3.4h8.3v1.3a4.7 4.7 0 0 0 9.4 0v-1.3H37v-3.4h-2.3Zm-9.4 4.7a1.3 1.3 0 0 1-2.6 0v-1.3h2.6v1.3Zm1.7-4.7H16.7v-9.3a7.3 7.3 0 1 1 14.6 0v9.3H27Z",
    fill: "current"
  })));
};
export default SvgIconBell48Line;